module.exports = __webpack_public_path__ + "static/media/medlemskab.f79cbad7.jpg";